import * as React from "react";
import _ from "lodash";
import "./ListItem.css";
import ProgressBar from '../../../ProgressBar/ProgressBar';
import Metadata from "../../../Metadata/Metadata";
import getCourseDifficultyLabel from "../../../../utils/getCourseDifficultyLabel";

declare const I18n;

type Props = {
  cardBackground?: "primary" | "secondary";
  title: string;
  requiredLevel: number;
  index: number;
  id: number;
  image?: string;
  isFacilitator?: boolean;
  isLearner?: boolean;
  completed?: boolean;
  learnerLevel?: number;
  handleDelete(id: number): void;
  description?: string;
  totalLessons?: number;
  lessonsCompleted?: number;
  currentLessonTitle?: string;
  currentLessonNumber?: number;
  currentLessonId?: number;
  buttonLabel?: string;
  showAdminControls?: boolean;
  totalDuration?: int;
  level?: string;
  hideImage?: boolean;
  isMiniLesson?: boolean;
};

const completedIcon = <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22.293 3.59375L8.625 17.2617L0.707031 9.34375L3.59375 6.45703L8.625 11.4883L19.4062 0.707031L22.293 3.59375Z" fill="#42C0C6" stroke="#4C1862" />
</svg>

const completedThumbsIcon = <svg width="101" height="90" viewBox="0 0 101 90" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M28 42L35.5 41L52 27L57.5 15L60 1L68.5 5.5L69.5 21L65 35L96.5 35.5L100 43.5L95 49.5L96.5 57L92.5 62L93.5 68L90 73L91 79.5L88.5 84.5H57.5L28 80.5V42Z" fill="#CAB2E0" />
  <rect x="2" y="37" width="25" height="52" fill="#42C0C6" />
  <circle cx="17" cy="76" r="4" fill="#813190" />
  <path d="M17.1816 70.4044C14.8103 70.4002 12.6715 71.8224 11.762 74.0075C10.8525 76.1926 11.3509 78.7094 13.0245 80.3846C14.6981 82.0598 17.219 82.5614 19.4118 81.6576C21.6004 80.7537 23.029 78.6183 23.029 76.2549C23.029 73.029 20.4126 70.4085 17.1816 70.4044ZM17.1816 79.2694C15.9607 79.2694 14.8601 78.5355 14.3908 77.4077C13.9257 76.2799 14.1832 74.982 15.047 74.1238C15.9108 73.2613 17.2107 73.0001 18.3361 73.4686C19.4657 73.933 20.2008 75.036 20.2008 76.255C20.2008 77.0511 19.881 77.8182 19.3162 78.3862C18.7514 78.9501 17.9832 79.2694 17.1816 79.2694ZM93.8573 34.1572H66.8709C69.3378 29.0572 70.7829 23.5257 71.1235 17.8743C71.4724 12.567 70.6667 8.32117 68.7107 5.13678C67.1616 2.52461 64.5702 0.704374 61.5883 0.123842C60.4919 -0.162258 59.3249 0.0533537 58.3988 0.708478C56.8248 1.95234 56.6879 4.30755 56.4636 8.22169V8.22584C56.3307 11.2527 56.0358 14.2712 55.5831 17.2686C54.9145 21.4523 51.0024 26.8218 44.2499 32.6811C41.0646 35.4342 37.7173 37.9884 34.2243 40.3352H29.2366V40.045C29.2325 37.5281 27.1892 35.4881 24.6642 35.484H4.57237C2.04737 35.4882 0.00416403 37.5281 0 40.045V85.4473C0.00415295 87.9641 2.05154 90 4.57237 90H24.6563C25.869 90.0041 27.0317 89.5231 27.8915 88.669C28.7512 87.8148 29.2329 86.6581 29.2371 85.4473V82.0929H36.5629C43.0581 85.7126 57.9421 85.9324 61.4514 85.9324H85.7339C87.6193 85.9365 89.43 85.1902 90.7631 83.8551C92.0963 82.5241 92.8397 80.7163 92.8355 78.8338V78.6721C92.8396 76.9099 92.1835 75.2057 90.9957 73.8955C93.7616 72.8382 95.593 70.1887 95.6013 67.2324V66.5731C95.6054 64.8067 94.9493 63.1027 93.7615 61.7965C95.975 60.9548 97.6279 59.0765 98.1719 56.7753C98.7201 54.4782 98.093 52.0567 96.4941 50.3111C99.2101 49.229 100.996 46.6002 101 43.677V41.2887C100.996 37.3497 97.798 34.1612 93.8569 34.157L93.8573 34.1572ZM26.3886 85.4471C26.3844 86.3966 25.6078 87.1637 24.6568 87.1637H4.57285C3.6177 87.1637 2.84523 86.3966 2.84106 85.4471V40.0368C2.84106 39.5766 3.01964 39.137 3.34773 38.8136C3.67165 38.4902 4.11187 38.3078 4.57284 38.3078H24.6567C25.6119 38.3078 26.3885 39.079 26.3885 40.0368L26.3886 85.4471ZM98.1604 43.6891C98.1646 46.0443 96.2667 47.964 93.9078 47.9972H86.9267C86.1459 47.9972 85.5106 48.6274 85.5106 49.407C85.5106 50.1865 86.146 50.8208 86.9267 50.8208H91.1793C93.5631 50.8208 95.4942 52.7489 95.4942 55.1289C95.4942 57.5088 93.5631 59.4411 91.1793 59.4411H84.9997C84.219 59.4411 83.5877 60.0713 83.5877 60.8509C83.5877 61.6304 84.2189 62.2647 84.9997 62.2647H88.455C90.8139 62.2979 92.7076 64.2177 92.7076 66.5728V67.232C92.7076 69.5872 90.8139 71.5069 88.455 71.5401H82.076C81.2953 71.5401 80.664 72.1703 80.664 72.9499C80.664 73.7335 81.2952 74.3637 82.076 74.3637H85.6933C86.8354 74.3637 87.9358 74.8157 88.7457 75.6242C89.5513 76.4328 90.0082 77.5315 90.0082 78.6718V78.8335C90.0082 79.9571 89.5596 81.0394 88.7623 81.8355C87.965 82.6316 86.8851 83.0793 85.7555 83.0793H62.1216C61.9389 83.0793 43.9195 83.2701 37.669 79.4472C37.4447 79.3186 37.1873 79.2482 36.9256 79.2482H29.2385V43.1584H34.5542C34.8242 43.1584 35.0941 43.0838 35.3184 42.9345C36.1905 42.383 56.4654 29.2514 58.2923 17.7035C58.7657 14.6103 59.0731 11.4964 59.2101 8.36973C59.3471 5.90678 59.4966 3.36927 60.0697 2.92558C60.3812 2.81777 60.7176 2.81777 61.0249 2.92558C66.0956 3.8502 68.7951 9.37733 68.2427 17.7118H68.2469C67.9313 23.7157 66.2244 29.5621 63.2592 34.7907C62.9934 35.2427 62.9934 35.7983 63.2592 36.2461C63.5042 36.7022 63.9818 36.9883 64.505 36.9883H93.8579C96.1919 37.0214 98.0731 38.9038 98.1105 41.2341L98.1604 43.6891Z" fill="#170035" />
</svg>

const ListItem: React.FunctionComponent<Props> = ({
  cardBackground = "primary",
  title,
  requiredLevel,
  index,
  id,
  handleDelete,
  image,
  isFacilitator,
  isLearner,
  learnerLevel,
  completed,
  description = "",
  totalLessons,
  lessonsCompleted,
  currentLessonTitle,
  currentLessonNumber,
  currentLessonId,
  buttonLabel,
  showAdminControls = false,
  totalDuration,
  level,
  hideImage = false,
  isMiniLesson = false
}: Props): JSX.Element => {
  const mod = index % 3;
  const [hovered, setHovered] = React.useState(false);
  let overlay = null;
  let levelText = `${I18n.t(
    "models.course.required_level.level"
  )} ${requiredLevel}`;

  const isAdmin = !(isLearner || isFacilitator);

  if (isAdmin) {
    completed = false
  }

  if (isLearner) {
    if (requiredLevel < learnerLevel) {
    } else if (requiredLevel > learnerLevel) {
      overlay = "card-list-item__image--locked";
    }
  }

  if (requiredLevel === 0) {
    levelText = I18n.t("models.course.required_level.0");
  } else if (requiredLevel === -1) {
    levelText = I18n.t("models.course.required_level.-1");
  }

  const imageNode = (
    <div className={`card-list-item__image-container ${overlay || ""} ${completed ? "completed-card-container" : ""}`}>
      {completed ? (
        <div className="empty-card-container" aria-label="No cover image">
          {completedThumbsIcon}
        </div>
      ) : image ? (
        <div
          className="card-list-item__image card-list-item__image--background"
          style={{ backgroundImage: `url(${image})` }}
          role="img"
          aria-label="Course image"
        />
      ) : (
        <div className="empty-card-container" aria-label="No cover image">
          <i
            className="fa fa-question-circle"
            style={{
              fontSize: "48px",
              border: "none",
              outline: "none",
              textDecoration: "none",
            }}
            aria-hidden="true"
          />
        </div>
      )}
      {overlay && (
        <div className="card-list-item__overlay">
          <i
            className={`fal ${overlay.includes("completed") ? "fa-check-circle" : "fa-lock"
              } card-list-item__overlay-icon`}
            style={{
              color: overlay.includes("completed") ? "#8DC862" : "#A41461",
            }}
          />
        </div>
      )}

      {(isFacilitator || isAdmin) && hovered && (
        <div className="facilitator-overlay">
          <button
            className="facilitator-btn"
            onClick={() => (window.location.href = `/courses/${id}/lessons`)}
          >
            {hideImage ? I18n.t("models.course.messaging.view_lesson") : I18n.t("models.course.messaging.view_course")}
          </button>
          <button
            className="facilitator-btn"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              window.location.href = `/courses/${id}/learners`;
            }}
          >
            {I18n.t("models.course.messaging.view_learners_progress")}
          </button>
        </div>
      )}
    </div>
  );

  // Determine in-progress: matches dashboard logic
  const inProgress = !!(
    isLearner &&
    (
      completed === true ||
      (lessonsCompleted ?? 0) > 0
    )
  );

  const primaryButtonText =
    buttonLabel || 
    (isLearner
      ? (inProgress && !completed
        ? I18n.t("common.continue")
        : (!isMiniLesson && completed) ? I18n.t("models.course.messaging.review_course")
        : isMiniLesson ? I18n.t("models.course.messaging.go_to_lesson")
        : I18n.t("models.course.messaging.go_to_course"))
      :isMiniLesson ? I18n.t("models.course.messaging.go_to_lesson")
      : I18n.t("models.course.messaging.view_course"));
  const courseType = (
    <div className={`type ${completed ? "review-course" : ""}`}>
      {completed && <i className="fa-solid fa-star"></i>}
      {primaryButtonText}
    </div>
  );

  return (
    <div
      className={`card-list-item course-card full-width ${cardBackground} ${completed ? "review-course-card" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        marginRight: mod === 0 || mod === 1 ? "1.2%" : 0,
        marginLeft: mod === 1 || mod === 2 ? "1.2%" : 0,
      }}
    >
      {!hideImage && (
        overlay === "card-list-item__image--locked" ? (
          imageNode
        ) : (
          <a
            style={{ cursor: "pointer", textDecoration: "none" }}
            href={`${isAdmin ? "/admin" : ""}/courses/${id}/lessons`}
          >
            {imageNode}
          </a>
        )
      )}

      <div className="card-list-item__meta-container">
        <div>
          <div className="card-list-item__title-container" style={{ marginTop: "20px" }}>
            <div id={`courses_title_${id}`} className="card-list-item__title">
              {title}
            </div>

            {isAdmin && showAdminControls && (
              <div className="card-list-item__admin-container">
                <a href={`/admin/courses/${id}/edit`}>
                  <i className="fal fa-edit card-list-item__icon--admin" />
                </a>
                <div id={`delete_${id}`} onClick={() => handleDelete(id)}>
                  <i className="fal fa-trash card-list-item__icon--admin" />
                </div>
              </div>
            )}
          </div>
          <Metadata
            smallText={false}
            alignLeft={true}
            items={[
              totalLessons > 0 && {
                icon: <i className="fa-regular fa-book" />,
                title: hideImage
                  ? `${totalLessons} ${I18n.t("models.course.type.lite_bytes")}`
                  : `${totalLessons} ${I18n.t(totalLessons === 1 ? "models.course.type.lesson" : "models.course.type.lessons")}`
              },
              totalDuration > 0 && {
                icon: <i className="fa-regular fa-clock" />,
                title: `${totalDuration} ${I18n.t("models.course.type.hours")}`
              },
              {
                icon: <i className="fa fa-signal" />,
                title: getCourseDifficultyLabel(level)
              }
            ].filter(Boolean)}
          />
          {isLearner && currentLessonTitle && (
            <div className="card-list-item__progress" style={{ marginTop: "0.25rem", fontSize: "0.9rem" }}>
              {currentLessonTitle}
            </div>
          )}
          {description !== null && (
            <div className="card-list-item__desc-container">
              <div
                id={`course_description_${id}`}
                className="card-list-item__description"
              >
                {description}
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
          }}
        >
          {
            !completed && currentLessonTitle && currentLessonNumber &&
            (
              <ProgressBar value={lessonsCompleted} total={totalLessons} card={true} />
            )
          }
          <div style={{ display: "flex", alignItems: "flex-end", gap: "0.5rem" }}>
            <a
              style={{ cursor: "pointer", textDecoration: "none" }}
              href={
                inProgress && currentLessonId && isLearner
                  ? `/courses/${id}/lessons/${currentLessonId}`
                  : `${isAdmin ? "/admin" : ""}/courses/${id}/lessons`
              }
              className={`btn btn-primary btn-resource ${inProgress && !completed
                ? "course-in-progress"
                : completed
                  ? "review-course"
                  : ""
                }`}
            >
              {courseType}
            </a>

            {completed && <div className="completed-box"><svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              {completedIcon}
            </svg>{I18n.t("models.course.messaging.completed")}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListItem;